import { render, staticRenderFns } from "./InsuranceCompanyEdit.vue?vue&type=template&id=4f8019e0&scoped=true&"
import script from "./InsuranceCompanyEdit.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8019e0",
  null
  
)

export default component.exports